/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-await-in-loop */
/* eslint-disable prefer-destructuring */
import i18next from "i18next"
import { isNull, isUndefined } from "lodash"
import StoreService from "./store"

class DynamicParamsService {
    /**
     * resolveParams Récupère les paramètres à partir du Store
     * @param params Liste des paramères
     * @param context context d'exection de l'action (ex. le client conserné par l'action)
     */
    public static async resolve(
        params: Array<unknown>,
        context?: any
    ): Promise<Array<unknown>> {
        try {
            const data: Array<any> = []
            for (let index = 0; index < params.length; index += 1) {
                const param = params[index]
                // détection dyn params dans un objets
                if (typeof param === "string" && param.indexOf("{{#") !== -1) {
                    const resolveRegex = /{{#(.*?)}}/gm
                    // on recupere tous les elements dynamiques contenus dans la variable
                    const matchedStringArray = param.match(resolveRegex)

                    if (matchedStringArray?.length) {
                        let resolvedElementArray = []
                        let resolvedString = ""
                        // à partir du tableau des elt dynamiques on fait le resolve
                        resolvedElementArray = await this.getDataFromStore(
                            matchedStringArray,
                            context
                        )

                        // si on a plus que un element on vient remplacer ces elements dans une chaine de caractaire
                        if (
                            resolvedElementArray &&
                            resolvedElementArray.length
                        ) {
                            // si on a un seul element à résoudre on tente de conserver le type original
                            if (
                                resolvedElementArray.length === 1 &&
                                matchedStringArray[0] === param
                            ) {
                                data.push(resolvedElementArray[0])
                            } else {
                                // sinon multi match dans chaine de caractaire
                                // ex. "Bonjour {{#...}} et bienvenue"
                                resolvedString = `${param}`
                                for (
                                    let j = 0;
                                    j < matchedStringArray.length;
                                    j += 1
                                ) {
                                    let resolvedElt = resolvedElementArray[j]
                                    if (
                                        isNull(resolvedElt) ||
                                        isUndefined(resolvedElt)
                                    )
                                        resolvedElt = ""
                                    resolvedString = resolvedString.replace(
                                        matchedStringArray[j],
                                        resolvedElt
                                    )
                                }
                                data.push(resolvedString)
                            }
                        } else {
                            // rien de résolue
                            resolvedString = ""
                            data.push(resolvedString)
                        }
                    } else {
                        // non trouvé dans la regex
                        data.push(param)
                    }
                } else {
                    // param non dynamique
                    // on renvoie le resultat comme tel
                    data.push(param)
                }
            }
            // on attend que toute les données soient disponibles
            return Promise.all(data)
        } catch (e: unknown) {
            throw Error(`Unable to retrieve params for Dialog ${e}`)
        }
    }

    public static resolveLang(data: any) {
        try {
            const param = data
            // détection dyn params dans un objets
            if (typeof param === "string" && param.indexOf("{{#") !== -1) {
                const resolveRegex = /{{#(.*?)}}/gm
                // on recupere tous les elements dynamiques contenus dans la variable
                const matchedStringArray = param.match(resolveRegex)

                if (matchedStringArray?.length) {
                    let element = matchedStringArray[0]
                    element = element.replace("{{#lang.", "").replace("}}", "")
                    return i18next.t(element)
                }
                // non trouvé dans la regex
                return data
            }
            // param non dynamique
            // on renvoie le resultat comme tel
            return data
        } catch (e: unknown) {
            throw Error(`Unable to retrieve params for Dialog ${e}`)
        }
    }

    /**
     * Fait un resove des éléments du tableau en param à partir du Store
     * @param keysArray tableau de clefs à résoudre dans le Store
     * @param context utilisé pour la source this
     */
    private static async getDataFromStore(
        keysArray: Array<string>,
        context?: any
    ) {
        const resolvedElementArray = []
        for (let i = 0; i < keysArray.length; i += 1) {
            let element = keysArray[i]
            // on enleve les marqueurs {{#}}
            element = element.replace("{{#", "").replace("}}", "")
            const resolvedElement = await StoreService.getInstance().get(
                element,
                [],
                context
            )
            resolvedElementArray.push(resolvedElement)
        }
        return resolvedElementArray
    }
}

export default DynamicParamsService
